import React from 'react';
import { useTranslation } from 'react-i18next';

const FunFact = () => {
	const { t } = useTranslation();
	return (
		<section className='bg-section'>
			<div className='container py-20 md:mt-30 flex flex-col gap-6 md:flex-row md:items-center'>
				<div className='Funfact flex flex-col gap-6 w-full md:w-2/3'>
					<p className='text-main text-md font-medium'>{t('Funfact')}</p>
					<p className='text-main text-3xl font-semibold'>
						{t('funfactTitle')}
					</p>
					<p className='text-textColor text-md'>{t('funfactText')}</p>
					<p className='text-white bg-secondary w-fit p-2 rounded flex gap-6 items-center text-main'>
						<span className='inline text-2xl font-bold'>2.4k+</span>
						{t('successfulStudentsLabel')}
					</p>
				</div>
				<div className='images w-full md:w-1/3 flex flex-col gap-4'>
					<div className='teacher bg-white p-2 shadow-sm flex gap-4 items-center rounded-md'>
						<div className='teacherImage p-3 text-white border-2 border-secondary w-[60px] md:w-[75px] flex justify-center items-center rounded-lg'>
							<img
								loading='lazy'
								src={'/images/learner.png'}
								alt='number of learners'
							/>
						</div>
						<div className='data flex flex-col'>
							<p className='text-main text-lg font-semibold'>2400+</p>
							<p className='text-main'>{t('learnersCount')}</p>
						</div>
					</div>

					<div className='teacher bg-white p-2 shadow-sm flex gap-4 items-center rounded-md'>
						<div className='teacherImage p-3 text-white border-2 border-secondary w-[60px] md:w-[75px] flex justify-center items-center rounded-lg'>
							<img
								loading='lazy'
								src={'/images/courses.png'}
								alt='courses'
							/>
						</div>
						<div className='data flex flex-col'>
							<p className='text-main text-lg font-semibold'>320+</p>
							<p className='text-main'>{t('totalCourses')}</p>
						</div>
					</div>

					<div className='teacher bg-white p-2 shadow-sm flex gap-4 items-center rounded-md'>
						<div className='teacherImage p-3 text-white border-2 border-secondary w-[60px] md:w-[75px] flex justify-center items-center rounded-lg'>
							<img
								loading='lazy'
								src={'/images/successfull.png'}
								alt='successful student'
							/>
						</div>
						<div className='data flex flex-col'>
							<p className='text-main text-lg font-semibold'>1340+</p>
							<p className='text-main'>{t('successfulStudents')}</p>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default FunFact;
